<template>
  <div class="flex space-x-2 mt-1 flex-wrap">
    <div
      v-for="productVariation in productVariations.slice(0, maxVariations)"
      :key="productVariation.id"
      class="size-5 ring-1 ring-gray-300 rounded-full cursor-pointer transition-all duration-200 shrink-0"
      :class="{
        'ring-gray-400 !ring-offset-1': productVariation.sku === selectedProduct?.sku
      }"
      :style="{ backgroundColor: productVariation.attribute_values.find((attribute) => attribute.attribute.code === 'true_color')?.default_value.code }"
      :title="productVariation.name"
      @click="$emit('select', productVariation)"
    />
    <a
      v-if="productVariations.length > maxVariations"
      class="text-base"
      :href="product.slug"
      :title="trans.get('miliboo.product.see-more')"
    >
      + {{ productVariations.length - maxVariations }}
    </a>
  </div>
</template>

<script setup>
import { inject, computed } from 'vue';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  selectedProduct: {
    type: Object,
    default: null,
  },
});

defineEmits(['select']);

const trans = inject('translate');

const maxVariations = 4;

const productVariations = computed(() => {
  const variations = props.product.product_variation;
  const sameSku = variations.find((variation) => variation.sku === props.product.sku);
  const others = variations.filter((variation) => variation.sku !== props.product.sku);

  if ((sameSku && variations.length === 1) || !variations.length) {
    return [];
  }

  return [sameSku ?? props.product, ...others];
});
</script>
